module.exports = __webpack_public_path__ + "media/Spread Your Wings.525b0e65.mp3";